import React, { memo } from 'react';
import { CancelIcon, EditIcon, SaveIcon } from './IconButtons';
import CloseModal from './CloseModal';
import InputField, { FileInput } from './InputField';
import CountryCodeDropdown from './CountryCodeDropdown';
import { countryPhoneCode, currencyList } from '../Constants/constant';
import Dropdown, { CurrencyDropdown } from './Dropdown';

const EditCandidate = memo(({data, errors, loading, disabled, onChange, onDownload = false, onClose, onEdit, onCancel, onSubmit, OnlyView = false }) => {
    const candidateEctcTypeOptions = [
        {value: "1", label: "LPA"},
        {value: "2", label: "%"},
    ];
    const genderOptions = [
        {value: "Male", label: "Male"},
        {value: "Female", label: "Female"},
    ];
    // console.log("data?.position_questions",data?.position_questions);

    return (
        <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
            <div onClick={(e) => { e.stopPropagation(); }} className='relative w-[70vw] bg-white overflow-auto mx-10 mb-5 py-5 px-8 rounded-2xl '>
                {!OnlyView && 
                (onEdit && disabled ? 
                <EditIcon disabled={loading} className=" top-3 left-8" onClick={onEdit} /> :
                <>
                    <CancelIcon disabled={loading} className=" top-3 left-8" onClick={onCancel} />
                    <SaveIcon disabled={loading} loading={loading} className=" top-3 left-36" onClick={onSubmit} />
                </>)
                }
                <CloseModal disabled={loading} onClick={onClose} />
                <h1 className='text-center text-xl font-semibold py-2 text-blue-950'>Candidate Information</h1>
                <form className='text-left flex flex-col gap-x-4 gap-y-3 px-2 max-h-[70vh] overflow-y-scroll'>
                    <div className='grid grid-cols-2 gap-3'>
                        <InputField
                            id="candidate"
                            name="candidate"
                            label="Name:"
                            type="text"
                            disabled={disabled}
                            placeholder={`Name`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate}
                            error={errors?.candidate}
                            onChange={onChange}
                            required
                        />
                        <InputField
                            id="candidate_email"
                            name="candidate_email"
                            label="Email:"
                            type="email"
                            disabled={disabled}
                            placeholder={`Email`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_email}
                            error={errors?.candidate_email}
                            onChange={onChange}
                            required
                        />
                        <div>
                            <h2 className={`flex text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Mobile:
                                <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                    <span className=" absolute top-[-2px] left-[3px]">*</span>
                                </span>
                            </h2>
                            <div className="flex items-start gap-2">
                                <CountryCodeDropdown id="phone_code" name="phone_code"
                                    onChange={onChange}
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled}
                                    placeholder={`Country Code`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.phone_code}
                                    error={errors?.phone_code}
                                    options={countryPhoneCode}
                                />
                                <InputField
                                    id="candidate_phone"
                                    name="candidate_phone"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Enter Mobile Number*`}
                                    textColor={disabled && "text-blue-700"}
                                    className="flex-1"
                                    value={data?.candidate_phone}
                                    error={errors?.candidate_phone}
                                    onChange={onChange}
                                />
                                
                            </div>
                        </div>
                        <div>
                            <h2 className={`block text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Alternate Mobile:</h2>
                            <div className="flex flex-grow items-start gap-2">
                                <CountryCodeDropdown id="phone_alt_code" name="phone_alt_code"
                                    onChange={onChange}
                                    onClose
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled}
                                    placeholder={`Country Code`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.phone_alt_code}
                                    error={errors?.phone_alt_code}
                                    options={countryPhoneCode}
                                />
                                <InputField
                                id="candidate_alt_phone"
                                name="candidate_alt_phone"
                                type="text"
                                disabled={disabled}
                                placeholder={`Enter Mobile Number`}
                                textColor={disabled && "text-blue-700"}
                                className="flex-1"
                                value={data?.candidate_alt_phone}
                                error={errors?.candidate_alt_phone}
                                onChange={onChange}
                                />
                            </div>
                        </div>
                        <InputField
                            id="candidate_location"
                            name="candidate_location"
                            label="Location:"
                            type="text"
                            disabled={disabled}
                            placeholder={`Location`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_location}
                            error={errors?.candidate_location}
                            onChange={onChange}
                            required
                        />
                        <InputField
                            id="candidate_qualification"
                            name="candidate_qualification"
                            label="Qualification:"
                            type="text"
                            disabled={disabled}
                            placeholder={`Qualification`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_qualification}
                            error={errors?.candidate_qualification}
                            onChange={onChange}
                            required
                        />
                        <div>
                            <h2 className={`flex text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Current CTC:
                                <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                    <span className=" absolute top-[-2px] left-[3px]">*</span>
                                </span>
                            </h2>
                            <div className='flex flex-grow items-start gap-2'>
                                <CurrencyDropdown 
                                    id="current_currency_code" 
                                    name="current_currency_code" 
                                    onChange={onChange}
                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                    disabled={disabled}
                                    placeholder={`Currency`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.current_currency_code}
                                    options={currencyList}
                                    error={errors?.current_currency_code}
                                />
                                <InputField
                                    id="candidate_current_ctc"
                                    name="candidate_current_ctc"
                                    className="flex-1"
                                    type="text"
                                    disabled={disabled}
                                    placeholder={`Current CTC`}
                                    textColor={disabled && "text-blue-700"}
                                    value={data?.candidate_current_ctc}
                                    error={errors?.candidate_current_ctc}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div>
                            <h2 className={`flex text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Expected CTC:
                                <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                    <span className=" absolute top-[-2px] left-[3px]">*</span>
                                </span>
                            </h2>
                                <div className='flex flex-grow items-start gap-2'>
                                    <Dropdown 
                                        id="candidate_ectc_type" 
                                        name="candidate_ectc_type"
                                        onChange={onChange}
                                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                        disabled={disabled}
                                        placeholder={`Type`}
                                        textColor={disabled && "text-blue-700"}
                                        value={data?.candidate_ectc_type}
                                        error={errors?.candidate_ectc_type}
                                        options={candidateEctcTypeOptions}
                                    />
                                    <CurrencyDropdown 
                                        id="expected_currency_code" 
                                        name="expected_currency_code" 
                                        onChange={onChange}
                                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                        disabled={disabled}
                                        placeholder={`Currency`}
                                        textColor={disabled && "text-blue-700"}
                                        value={data?.expected_currency_code}
                                        options={currencyList}
                                        error={errors?.expected_currency_code}
                                    />
                                    {/* {data?.candidate_ectc_type && ( */}
                                        <InputField
                                            id="candidate_expected_ctc"
                                            name="candidate_expected_ctc"
                                            type="text"
                                            className="flex-1"
                                            disabled={disabled || !data?.candidate_ectc_type}
                                            placeholder={`Expected CTC`}
                                            textColor={disabled && "text-blue-700"}
                                            value={data?.candidate_expected_ctc}
                                            error={errors?.candidate_expected_ctc}
                                            onChange={onChange}
                                        />
                                    {/* )} */}
                                    {/* <ErrorMessage name="candidate_ectc_type" component="div" className="text-red-600 text-sm" /> */}
                                </div>
                        </div>
                        <InputField  
                        id="candidate_dob" 
                        name="candidate_dob" 
                        label="Date Of Birth:"
                        type="date" 
                        disabled={disabled}
                        textColor={disabled && "text-blue-700"}
                        value={data?.candidate_dob}
                        error={errors?.candidate_dob}
                        onChange={onChange}
                        />
                        <InputField
                        id="candidate_industry"
                        name="candidate_industry"
                        label="Industry:"
                        type="text"
                        disabled={disabled}
                        placeholder={`Current/Past Industry`}
                        textColor={disabled && "text-blue-700"}
                        value={data?.candidate_industry}
                        error={errors?.candidate_industry}
                        onChange={onChange}
                        required
                        />
                        <InputField
                            id="candidate_organization"
                            name="candidate_organization"
                            label="Organization:"
                            type="text"
                            disabled={disabled}
                            placeholder={`Current/Past Organization`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_organization}
                            error={errors?.candidate_organization}
                            onChange={onChange}
                        />
                        <InputField
                            id="candidate_designation"
                            name="candidate_designation"
                            label="Designation:"
                            type="text"
                            disabled={disabled}
                            placeholder={`Current/Past Designation`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_designation}
                            error={errors?.candidate_designation}
                            onChange={onChange}
                        />
                        <InputField
                            id="candidate_experience"
                            name="candidate_experience"
                            label="Experience:"
                            type="text"
                            disabled={disabled}
                            placeholder={`Experience`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_experience}
                            error={errors?.candidate_experience}
                            onChange={onChange}
                            required
                        />
                        <InputField
                            id="candidate_notice_period"
                            name="candidate_notice_period"
                            label="Notice Period:"
                            type="text"
                            disabled={disabled}
                            placeholder={`Notice Period In Days`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_notice_period}
                            error={errors?.candidate_notice_period}
                            onChange={onChange}
                            required
                        />
                        <Dropdown 
                            id="candidate_gender" 
                            name="candidate_gender"
                            label="Gender:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            disabled={disabled}
                            placeholder={`Select`}
                            textColor={disabled && "text-blue-700"}
                            value={data?.candidate_gender}
                            error={errors?.candidate_gender}
                            options={genderOptions}
                            required
                        />
                        <FileInput
                        name="candidate_resume"
                        label="Upload Resume:"
                        placeholder={`Upload`}
                        accept=".pdf,.doc,.docx"
                        textColor={disabled && "text-blue-700"}
                        disabled={disabled}
                        value={data?.candidate_resume}
                        error={errors?.candidate_resume}
                        onDownload={() => onDownload(data?.id, data?.candidate)}
                        onSelect={onChange} />
                    </div>
                    <div>
                        <h2 className={`block text-left font-medium ${disabled ? "text-blue-700" : "text-gray-700"} mb-1`}>Remarks</h2>
                        <textarea name="candidate_remarks" id="candidate_remarks" rows="5"
                        className='w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                        disabled={disabled} placeholder="Enter Remark..." onChange={onChange}
                        >{data?.candidate_remarks}
                        </textarea>
                    </div>
                    <hr className=' mt-2' />
                    { Array.isArray(data?.position_questions) && (data?.position_questions.length > 0) &&
                    ( <><h1 className='text-center text-xl font-semibold text-blue-950'>Related Questions</h1>
                    <div className='grid grid-cols-1 gap-3 mt-3 '>
                        {data?.position_questions?.map((item, idx) => (
                            <div key={idx} className="w-full mb-4 p-4 border rounded-md shadow-sm bg-gray-50">
                                <div className="flex justify-between items-start">
                                <div className="w-full">
                                    <h2 className="text-sm font-semibold text-gray-700 mb-1">{`Question ${idx + 1}${item?.is_mandatory == 1 ? 
                                        <span className="bg-red-100 text-red-600 rounded-full relative w-3.5 h-3.5">
                                            <span className=" absolute top-[-2px] left-[3px]">*</span>
                                        </span> : ''}`}</h2>
                                    <p className="text-gray-800 mb-2">{item?.question_text}</p>
                                    <InputField
                                        id={`answer`}
                                        name={`answer`}
                                        className="w-full"
                                        placeholder="Write your answer"
                                        value={item?.response_text}
                                        error={item?.error_text}
                                        onChange={(e)=> onChange(e,item.question_id)}
                                    />
                                </div>
                                </div>
                            </div>
                        ))}

                    </div></>)}
                </form>
            </div>
        </div>
    );
})

export default EditCandidate;
